<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5" >
              


                <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Spare Parts  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Invoice</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/tcreditnotes/index">  Manage Credit Notes </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{quatations.credit_num }}</h6>


                <!-- <img :src="imageUrl" alt="Your Image">
                <img src="../../../public/img/evenware-logo.png" width="140px" alt="Evenware Logo"> -->
            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->




                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       
                
                  
                  <button v-if="quatations.status==1"  @click="Update()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                  <button v-if="quatations.status==1"  @click="Confimmodel()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Confirm</button>
                  <button type="button"v-if="quatations.status!=1"  @click="generatePDF()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button>
                
                 
            
                </div>
                <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>

  
  </b-modal>




                <div class="card custom_bdr_rds">
                <div style="background-color: #f2f3f4; " class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless table-responsive ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>Credit Note No. </b></td>
                           <td>{{ quatations.credit_num }}</td> 
                          </tr>
                          <tr>
                            <td><b>Credit Note Date</b></td>
                           <td>{{ quatations.credit_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Invoice Number</b></td>
                           <td>{{ quatations.relatedToInvoice.invoice_num }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Name</b></td>
                           <td>{{ quatations.relatedToCustomer.C_name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Credit Amount </b></td>
                           <td>{{ quatations.credit_amt }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>Remark </b></td>
                           <td>{{ quatations.remark }}</td> 
                          </tr>
                          <tr>
                            <td><b>Invoice Type </b></td>
                           <td>{{ quatations.relatedToInvoice.invoice_type }} </td> 
                          </tr>
                          <tr>
                            <td><b>Status </b></td>
                           <td>{{ quatations.relatedToStatus.status }}</td> 
                          </tr>
                          <tr>
                            <td><b>Username </b></td>
                           <td>{{ quatations.relatedToUser.username }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created Date </b></td>
                           <td>{{ quatations.created_date }}</td> 
                          </tr>
                          
                         
                           
                        </tbody>
                 
                 
                      </table>



                      <div class="card custom_bdr_rds">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Return Invoice Item List</b></h6>

                                <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead style="border-bottom: 2px solid black; ">
                              <tr>
                              <th>#</th>
                              <th>Product Description</th>
                              <th class="text_right">Invoiced Qty</th>
                              <th class="text_right">Return Qty</th>
                              <th class="text_right">Discount</th>
                              <th class="text_right">Unit Price	</th>
                              <th class="text_right">Line Amount</th>
                              <th class="ps-4">Remark</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(detail, index) in details" :key="detail.id">
                              <td>{{ index+1 }}</td>
                              <td>{{detail.P_description}} ({{ detail.P_code }})</td>
                              <td class="text_right">{{detail.invqty}}</td>
                              <td class="text_right">{{detail.rtrnqty}}</td>
                              <td class="text_right">{{detail.discount}}</td>
                              <td class="text_right">{{detail.invoiced_price}}</td>
                              <td class="text_right">{{detail.line_amount}}</td>
                              <td class="ps-4" >{{detail.item_rtn_remark}}</td>
                              </tr>
                              <tr style="border-top: 2px solid black; " >
                              <td></td>
                              <th>Total :</th>
                              <th class="text_right">{{ total.total_invqty }}</th>
                              <th class="text_right">{{ total.total_rtrnqty }}</th>
                              <td></td>
                             
                              <td></td>
                             
                              <th class="text_right"></th>
                              <th ></th>
                              </tr>
                              
                            </tbody>

                          </table>
</div>

                        </div>
                    </div>






                    <div class="card custom_bdr_rds">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                          <div class="table-responsive"> 
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless  ">
                            <thead style="border-bottom: 2px solid black; ">
                              <tr>
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>
</div>  

                        </div>
                    </div>



                    <div class="card custom_bdr_rds">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>CRM Notes</b></h6>

                   <div class="table-responsive"> 
              <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                  <thead style="border-bottom: 2px solid black; ">
                    <tr>
                    <th>#</th>
                    <th>Comment</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  >
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  
                    
                    </tr>
                  </tbody>

                </table>
</div>

              </div>
          </div>


          <div class="card custom_bdr_rds">
            <div class="card-body custom_bdr_rds">
                <h6 class="purchitem mb-2"><b>Add CRM Notes</b></h6>

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3"   style="font-size: small;" class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select" v-model="selectedOption">
                              <option  selected>Select....</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input type="date"  style="font-size: small;" class="form-control" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input   style="font-size: small;" class="form-control" >
                    </div>
                  </div>


                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button   class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Save</button>
                </div>
                </div>

            </div>
        </div>







   

<br><br>





                




                </div>
                </div>
              </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSquatation()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            total:{},
            quatations:{},
            category:{},
            brand:{},
            supplier:{},
            status:{},
            user:{},
            all_code:{},
            details:[],
            trans:[],
            width:5,
            height:5,
            infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },

        // imageUrl: '/img/evenware-logo.png' 
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          
           generatePDF() {
         
      const doc = new jsPDF();
      
      function addPageBorders(doc) {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Set the border style
    doc.setDrawColor(71, 144, 255); // Black color
    doc.setLineWidth(15); // Border width

    // Draw a line at the top of the page
    doc.line(0, 0, pageWidth, 0);
    // Draw a line at the bottom of the page
    doc.line(0, pageHeight, pageWidth, pageHeight);
}
     // Update this with your image URL or file path
   
      var img = new Image()
    img.src = '/img/evenware-logo.png'
    const imageWidth = doc.internal.pageSize.getWidth() - 550; // Adjust 20 if you need margins
  const imageHeight = (imageWidth * 3) / 4; // Assuming the aspect ratio is 4:3, adjust as needed
  
  doc.addImage(img, 'png', 10, 13, imageWidth, imageHeight);
  doc.setFontSize(18);
  doc.setFont('Helvetica', 'bold');
  doc.text('CREDIT NOTE', 105, 30, null, null, 'center');
  doc.setFontSize(12);
  
  doc.text('Demonstration System', 10, 45, null, null);

  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(8);
  doc.text('No 08, Rodrigo Mawatha,', 10, 48, null, null);
  doc.text('Nawala Road,', 10, 51, null, null);
  doc.text('Rajagiriya,', 10, 54, null, null);
  doc.text('Colombo 08,', 10, 57, null, null);
  doc.text('Sri Lanka', 10, 60, null, null);
  doc.text('Tel : 0112 806 776-9,', 10, 63, null, null);
  doc.text('Web : colombo@cmc.slt.lk ,', 10, 66, null, null);


  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Creadit Note To:', 85, 45, null, null);
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.quatations.relatedToCustomer.C_name, 85, 48, null, null);
 
  doc.text(this.quatations.relatedToCustomer.C_address_line1, 85, 51, null, null);
  doc.text(this.quatations.relatedToCustomer.C_address_line2, 85, 54, null, null);
  doc.text(this.quatations.relatedToCustomer.C_address_line3, 85, 57, null, null);

  


  

  
  
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Credit Note No:', 200, 45, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.quatations.credit_num, 200, 49, null, null, 'right');

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Invoice No:', 200, 53, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.quatations.relatedToInvoice.invoice_num, 200, 56, null, null, 'right');


  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Sales Person:', 200, 60, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.quatations.relatedToInvoice.relatedToSalesPerson.name, 200, 63, null, null, 'right');

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Payment Terms:', 200, 67, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.quatations.relatedToInvoice.relatedToSo.payment_method, 200, 70, null, null, 'right');
  
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Date:', 200, 74, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.quatations.credit_date, 200, 77, null, null, 'right');


 

 
 
  const tableData = [
        ['No', 'Product Code', 'Product Description', 'QTY', 'UNIT PRICE ', 'TOTAL']
    ];
    

    this.details.forEach(detail => {
        tableData.push([
            detail.no,
            detail.P_code,
            detail.P_description,
            { content: detail.rtrnqty, styles: { halign: 'right' } },
            { content: detail.invoiced_price, styles: { halign: 'right' } },
            { content: detail.line_amount, styles: { halign: 'right' } },
           
         
           
           
           
          
        ]);
    });

        // Add table to the PDF
        doc.autoTable({
            startY: 85, // Y position to start the table
            head: [tableData[0]], // Table header
            body: tableData.slice(1),
            addPageContent: function(data) {
        addPageBorders(doc); // Call the function to add page borders
    },
    styles: {
        font: 'Helvetica',
        fontSize:8,
    },
            // Table data excluding header
        });
 
     
        const tableBottomY = doc.lastAutoTable.finalY;

        doc.setFontSize(8);
        doc.setFont('Helvetica', 'bold');
        doc.text('Sub Total: '+this.total.sub_total, 195, tableBottomY+10, null, null, 'right');



        doc.setFontSize(9);
        doc.setFont('Helvetica', 'normal');
        doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY+35, null, null);
        doc.text('* Settlement should be made within 5 days', 10, tableBottomY+40, null, null);
        doc.text('* Any complaints should be informed within 3 days after receiving the goods.', 10, tableBottomY+45, null, null);
        doc.text('* Complaints after 3 days will not be accepted under any circumstances.', 10, tableBottomY+50, null, null);
        doc.text('* Bank Details : Commercial Bank (7056), Old Moor Street Branch (017), A/C No. 100 039 2638. ', 10, tableBottomY+55, null, null);
        doc.text('* The above Invoice is inclusive of all taxes.', 10, tableBottomY+60, null, null);
        


  
        doc.output('dataurlnewwindow');



    },
          async Confirm(id) {
       
    
       try {
         const { data} = await  axios.post('/tcreditnotes/confirm?id='+id,{userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },
          async Update(){
        this.$router.push('/quotation/update?id='+this.id);
      },




      async Confimmodel(){
        this.infoModal1.content = this.id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },
          async Createso(){
        this.$router.push('/ssalesorder/create?id='+this.id);
      },

            async loadSquatation() {
        console.log("Amila");
    
      try {
        const { data} = await  axios.get('/tcreditnotes/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.quatations = data.alldata
         this.details = data.details
         this.total = data.total
        //  this.all_code = data.all_code
       
       
        
      } catch (error) {
        console.log(error.response);
      }
    },

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>